import styled, { css, keyframes } from 'styled-components'

export const loadingAnimation = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

export const LoadingRows = styled.div`
  display: grid;

  & > div {
    animation: ${loadingAnimation} 1.5s infinite;
    animation-fill-mode: both;
    background: linear-gradient(
      to left,
      ${({ theme }) => theme.cardPrimary} 25%,
      ${({ theme }) => theme.cardSecondary} 50%,
      ${({ theme }) => theme.cardPrimary} 75%
    );
    background-size: 400%;
    border-radius: 12px;
    height: 2.4em;
    will-change: background-position;
  }
`

export const DynamicSizedLoadingRow = styled(LoadingRows)<{
  height?: string
  borderRadius?: string
  borderTopLeftRadius?: string
  borderTopRightRadius?: string
  borderBottomLeftRadius?: string
  borderBottomRightRadius?: string
}>`
  & > div {
    height: ${({ height }) => height || '2.4em'};
    border-radius: ${({ borderRadius }) => borderRadius || '12px'};
    border-top-left-radius: ${({ borderTopLeftRadius }) => borderTopLeftRadius || '0px'};
    border-top-right-radius: ${({ borderTopRightRadius }) => borderTopRightRadius || '0px'};
    border-bottom-left-radius: ${({ borderBottomLeftRadius }) => borderBottomLeftRadius || '16px'};
    border-bottom-right-radius: ${({ borderBottomRightRadius }) => borderBottomRightRadius || '16px'};
  }
`

const loadingAnimationOpacity = keyframes`
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.4
  }
  100% {
    opacity: 0.8;
  }
`

export const loadingOpacityMixin = css<{ $loading: boolean }>`
  opacity: ${({ $loading }) => ($loading ? '0.4' : '1')};

  animation: ${({ $loading }) => ($loading ? loadingAnimationOpacity : null)} 1s infinite;
  transition: opacity 0.2s ease-in-out;
`

export const LoadingOpacityContainer = styled.div<{ $loading: boolean }>`
  ${loadingOpacityMixin}
`
